import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import InterventionVisitForm from "./InterventionVisitForm";

interface AddAssessmentVisitModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: any) => void;
    patientId: string;  // Tambahkan patientId
    visitId: string;  // Tambahkan patientId
}

const AddAssessmentVisitModal: React.FC<AddAssessmentVisitModalProps> = ({ isOpen, onClose, onSubmit, patientId, visitId }) => {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" open={isOpen} onClose={onClose}>
                <div className="fixed inset-0 z-[999] overflow-y-auto bg-black/60">
                    <div className="flex min-h-screen items-center justify-center px-4">
                        <Dialog.Panel className="panel my-8 w-full max-w-lg overflow-hidden rounded-lg p-2 text-black dark:text-white-dark">
                            <div className="flex items-center justify-between bg-[#fbfbfb] px-4 pt-3 pb-0 dark:bg-[#121c2c]">
                                <h5 className="text-lg font-bold">Add Assessment</h5>
                                <button type="button" className="text-white-dark hover:text-dark" onClick={onClose}>
                                    ❌
                                </button>
                            </div>
                            <div className="p-5">
                                <InterventionVisitForm onSubmit={onSubmit} patientId={patientId}  visitId={visitId} />
                            </div>
                        </Dialog.Panel>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};
export default AddAssessmentVisitModal;
